module.exports = function() {
  return new Worker(__webpack_public_path__ + "cac1d7f006014a58f15e.worker.js");
};